//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"

export default function QuestionSmall({ question }) {
  let name = `${question.text} [${question.type}]`

  return (
    <div className={myStyles.questionOrderSmall}>
      <div>{name}</div>

      <div>
        <small style={{ color: "gray" }}>{question.helpText}</small>
      </div>
    </div>
  )
}
